<template>
    <div class="vue-mega-menu" v-show-slide="open">
        <div class="container">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import VShowSlide from 'v-show-slide'
Vue.use(VShowSlide);

export default {
    name: "MegaMenu",

    props: ['eventBus'],

    data() {
        return {
            open: false
        }
    },

    mounted() {
        this.eventBus.$on('open-mega-menu', (payload) => {
            this.open = payload;
        })
    }
}
</script>